import React from 'react'
import PropTypes from 'prop-types'

import MultiSelect from '@kenshooui/react-multi-select'

import helpers from 'helpers'

import useStyles from './styles'

const SelectExistingField = ({
  companyFragilities,
  selectedItems,
  onChange,
}) => {
  const classes = useStyles()

  const items = companyFragilities.map((fragility) => ({
    id: fragility?.id,
    label: fragility?.name,
  }))

  const multiSelectSearch = (value) => (item) =>
    String(item.label).toLowerCase().includes(value.toLowerCase()) ||
    String(item.group).toLowerCase().includes(value.toLowerCase())

  return (
    <MultiSelect
      messages={helpers.dataCollected.messagesMultiSelect()}
      items={items}
      selectedItems={selectedItems}
      filterFunction={multiSelectSearch}
      onChange={onChange}
      wrapperClassName={classes.multiSelect}
    />
  )
}

SelectExistingField.propTypes = {
  companyFragilities: PropTypes.array,
  selectedItems: PropTypes.array,
  onChange: PropTypes.func.isRequired,
}

export default SelectExistingField
